import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Constants from "../../services/Constants.json";

const RecaptchaComponent = ({ onChangeCaptcha }) => {
  if (!Constants.isRecaptchaEnabled) {
    return null;
  }
  return (
    <div>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <ReCAPTCHA
          // sitekey={Constants.SiteKey}
          sitekey="6Leo7aAsAAAAACB5HBnsNIXzRHCVntxILf5ckg8B"
          onChange={onChangeCaptcha}
        />
      </div>
    </div>
  );
};

export default RecaptchaComponent;
